<div class="main-card mb-3 card">
    <div class="card-header">
        <div class="card-header-title font-size-lg text-capitalize fw-normal">
            Invoice History
        </div>
    </div>
    <div class="table-responsive">
        <table
            class="align-middle text-truncate mb-0 table table-borderless table-hover">
            <thead>
                <tr>
                    <th class="text-center">#</th>
                    <th class="text-center">DATE</th>
                    <th class="text-center">INVOICE NO</th>
                    <th class="text-center">CUSTOMER NAME</th>
                    <th class="text-center">DUE DATE</th>
                    <th class="text-center">STATUS</th>
                    <th class="text-center">E-MAIL</th>
                    <th class="text-center">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let agent of invoice_list.slice((page2 - 1) * pageSize, page2 * pageSize); let i = index">
                    <td class="text-center">{{ ((page2 - 1) * pageSize) + i + 1
                        }}</td>
                    <td class="text-center">{{ agent.date }}</td>
                    <td class="text-center">{{ agent.invoice_number }}</td>
                    <td class="text-center">{{ agent.customer_name }}</td>
                    <td class="text-center">{{ agent.due_date }}</td>
                    <td class="text-center">
                        <div
                            *ngIf="agent.payment_status === 'Paid'; else dueDateTemplate"
                            class="badge rounded-pill bg-success">
                            {{ agent.payment_status }}
                        </div>
                        <ng-template #dueDateTemplate>
                            <div class="badge rounded-pill bg-danger">
                                {{ agent.due_days }}
                            </div>
                        </ng-template>
                    </td>
                    <td class="text-center">{{ agent.email }}</td>

                    <td class="text-center">
                        <div class="btn-group-sm btn-group">
                            <button class="btn-shadow btn btn-primary"
                                ngbTooltip="View"
                                (click)="viewInvoice(agent.id,agent.invoice_number)">View
                            </button>
                            <button class="btn-shadow btn btn-primary"
                                ngbTooltip="Download"
                                (click)="downloadInvoice(agent.id,agent.invoice_number)">
                                <i class="pe-7s-cloud-download"></i>
                            </button>

                            <!-- <button class="btn-shadow btn btn-primary"
                                ngbTooltip="Download"
                                (click)="downloadBlobPDF(agent.id,agent.invoice_number)">
                                <i class="pe-7s-cloud-download"></i>
                            </button> -->
                        </div>
                    </td>
                </tr>
                <!-- When no data found -->
                <tr *ngIf="invoice_list && invoice_list.length === 0">
                    <td class="text-center" colspan="8">No data found.</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- Pagination -->
<ngb-pagination
    [collectionSize]="invoice_list.length"
    [(page)]="page2"
    [pageSize]="pageSize"
    [maxSize]="5"
    [rotate]="true"
    [boundaryLinks]="true">
</ngb-pagination>

<!-- PDF Viewer Modal -->
<!-- PDF View Modal -->
<div class="modal fade show d-block" tabindex="-1" role="dialog"
    *ngIf="showPdfModal" style="background-color: rgba(0, 0, 0, 0.5);">

    <div
        class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-xl"
        role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">Invoice Preview</h5>
                <button type="button" class="close btn btn-danger btn-sm"
                    (click)="closePdfModal()">
                    &times;
                </button>
            </div>

            <div class="modal-body p-0">
                <object *ngIf="pdfUrl"
                    [data]="pdfUrl"
                    type="application/pdf"
                    width="100%"
                    height="600px"
                    style="border: none;">
                    <p>PDF cannot be displayed. <a [href]="pdfUrl"
                            target="_blank">Open in a new tab</a>.</p>
                </object>
                <div *ngIf="!pdfUrl" class="text-center p-4">
                    <p>Loading PDF...</p>
                </div>
            </div>

        </div>
    </div>
</div>
